<template>
    <div class="animate__animated animate__fadeIn">
        <div class="row">
            <form-select
                :itens="$root.arrays.ato_inflacional"
                v-model="atoInfracional.ato_infracional"
                label="Ato infracional"
            />
            <form-select
                :itens="$root.arrays.reincidencia"
                v-model="atoInfracional.reincidencia"
                label="Reincidência?"
                grid="6"
            />
            <form-select
                :itens="$root.arrays.assessoramento_juridico"
                v-model="atoInfracional.assessoramento_juridico"
                label="Assessoramento Jurídico"
                grid="6"
            />
            <label class="col-12 font-weight-bold my-3">
                Guia de Execução de Medida Socioeducativa
            </label>
            <form-input
                v-model="atoInfracional.numero"
                label="Número"
                grid="6"
            />
            <form-input
                v-model="atoInfracional.autos"
                label="Autos nº"
                grid="6"
            />
            <form-select
                :itens="$root.arrays.documentos_recebidos"
                v-model="atoInfracional.documentos_recebidos"
                :multiple="true"
                label="Documentos recebidos referente a MSE em execução e execuções anteriores:"
            />

            <form-textarea-editor
                class="mt-3"
                v-model="atoInfracional.outros_documentos"
                label="Outros Documentos"
            />
        </div>
        <div class="row px-2 d-flex justify-content-end">
            <button
                class="btn btn-success btn-submit"
                data-style="zoom-in"
                @click="submit"
                type="submit"
            >
                <i class="mdi mdi-content-save" />
                {{ $t("Salvar") }}
            </button>
        </div>
    </div>
</template>
<script>
export default {
    props: ["medida"],
    data() {
        return {
            atoInfracional: {
                ato_infracional: "",
                reincidencia: "",
                assessoramento_juridico: "",
                numero: "",
                autos: "",
                documentos_recebidos: "",
                outros_documentos: "",
            },
        };
    },
    mounted() {
        if (this.medida.atoInfracional) {
            this.atoInfracional = this.medida.atoInfracional;
        }
    },
    methods: {
        submit() {
            this.medida.atoInfracional = this.atoInfracional;
            this.$emit("submit");
        },
    },
};
</script>
